export const actions = {
    GET_MAIN_MENU_DATA: 'GET_MAIN_MENU_DATA',
    SET_MAIN_MENU_DATA: 'SET_MAIN_MENU_DATA',
    GET_MAIN_COURSEMENU_TAB_DATA: 'GET_MAIN_COURSEMENU_TAB_DATA',
    SET_MAIN_COURSEMENU_TAB_DATA: 'SET_MAIN_COURSEMENU_TAB_DATA',
    GET_MAIN_COURSEMENU_CONTENT_DATA: 'GET_MAIN_COURSEMENU_CONTENT_DATA',
    SET_MAIN_COURSEMENU_CONTENT_DATA: 'SET_MAIN_COURSEMENU_CONTENT_DATA'
};
